import vidFleetComponent from 'Modules/.common/components/VidFleetVideo/lan/es';
import infoBubbleComponent from 'Modules/.common/components/InfoBubble/lan/es';
import dtcComponent from 'Modules/.common/components/Dtc/lan/es';
import sharedMediaComponent from 'Modules/.common/components/SharedMedia/lan/es';
import accountInformationComponent from 'Modules/.common/components/AccountInformation/lan/es';
import smartWitnessComponent from 'Modules/.common/components/SmartWitnessVideo/lan/es';
import mapIconPickerComponent from 'Modules/.common/components/IconPicker/lan/es';
import troubleshootDevice from 'Modules/.common/components/TroubleshootDevice/lan/es';
import cameraSetup from 'Modules/.common/components/CameraSetup/lan/es';
import warnings from 'Modules/.common/components/Warnings/lan/es';
import videoAssignDriver from 'Modules/.common/components/VideoAssignDriver/lan/es';
import video from 'Modules/.common/components/Video/lan/es';
import transactionsSummary from 'Modules/.common/components/TransactionsSummary/lan/es';
import filterAvatars from 'Modules/.common/components/FilterAvatars/lan/es';
import driverPerformance from 'Modules/driverPerformance/.globals/lan/es';
import evirPx from 'Modules/evirPx/.globals/lan/es';
import lightMetricsVideo from 'Modules/.common/components/LightMetricsVideo/lan/es';
import mitacVideo from 'Modules/.common/components/MitacVideo/lan/es';
import entityPickerComponent from 'Modules/.common/components/EntityPicker/lan/es';
import entityUnitDriverSelectorComponent from 'Modules/.common/components/EntityUnitDriverSelector/lan/es';
import entityTagViewerComponent from 'Modules/.common/components/EntityTagViewer/lan/es';
import oemDataModalComponent from 'Modules/.common/components/OemDataModal/lan/es';
import oemRemoteCommandsComponent from 'Modules/.common/components/OemDataModal/remoteCommands/lan/es';
import requestVideoComponent from 'Modules/.common/components/RequestVideo/lan/es';

let locales = {}

locales = {
  exportMessageSuccess: 'La exportación ha sido generada correctamente.',
  exportMessageFailed: 'Lo sentimos, ocurrió un error durante la generación del archivo.',
  exportMessageFailedNoData: 'no se encontró información para exportar.',
  ...locales,
  ...vidFleetComponent,
  ...infoBubbleComponent,
  ...dtcComponent,
  ...sharedMediaComponent,
  ...accountInformationComponent,
  ...smartWitnessComponent,
  ...mapIconPickerComponent,
  ...troubleshootDevice,
  ...warnings,
  ...videoAssignDriver,
  ...cameraSetup,
  ...video,
  ...transactionsSummary,
  ...filterAvatars,
  ...driverPerformance,
  ...evirPx,
  ...lightMetricsVideo,
  ...mitacVideo,
  ...entityPickerComponent,
  ...entityUnitDriverSelectorComponent,
  ...entityTagViewerComponent,
  ...oemDataModalComponent,
  ...oemRemoteCommandsComponent,
  ...requestVideoComponent
};

export default locales;
